import { Brand, createBranded } from '@deltasierra/type-utilities';

export type MediaTemplateDocumentAssetId = Brand<string, 'MediaTemplateDocumentAssetId'>;
export const MediaTemplateDocumentAssetId = createBranded<MediaTemplateDocumentAssetId>();
